var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm._isMobile() ? 'mobile' : '']},[_c('div',{staticClass:"login_backgroun",style:({ backgroundImage: 'url(' + _vm.backgroundImage + ')' })},[_c('div',{staticClass:"login_content"},[_c('div',{staticClass:"login_right login_box"},[_c('p',{staticClass:"title"},[_vm._v("注册学习系统")]),_c('Register')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }